export const menu = state => state.menu

export const sidebar_is_opened = state => {
    return state.menu.sidebar_opened
}